import { Category } from "src/common/types/visit";
import { AnyAction } from "redux";
import { internalActionKeys } from "../actions/internalActionKeys";
import reduceReducers from "reduce-reducers";
import visitCategoriesReducer from "src/common/reducers/visitCategoriesReducer";
import { toast } from "react-toastify";
import { sortVisitOptions } from "../../common/utilities/visitOptionUtils";
import internalReasonsReducer from "./internalReasonsReducer";

function internalVisitCategoriesReducer(state: Category[] = [], action: AnyAction): Category[] {
  switch (action.type) {
    case internalActionKeys.PATCH_CATEGORY_SUCCESS:
      return updateCategories(state, action.updatedCategory);
    case internalActionKeys.PATCH_CATEGORY_FAILURE:
      return state;
    default:
      return state;
  }
}

const updateCategories = (categories: Category[], updatedCategory: Category): Category[] => {
  const categoriesCopy = [
    ...categories.map(c => {
      return { ...c };
    })
  ];
  const catIndex = categoriesCopy.findIndex(c => c.id == updatedCategory.id);
  if (catIndex > -1) {
    categoriesCopy[catIndex] = updatedCategory;
    return sortVisitOptions(categoriesCopy) as Category[];
  } else {
    toast.error("An error occurred when trying to update categories");
    return categories;
  }
};

export default reduceReducers<Category[]>(
  internalVisitCategoriesReducer,
  visitCategoriesReducer,
  internalReasonsReducer
);
